import type { TreeItemProps } from "@mui/x-tree-view";
import type { JSXElementConstructor } from "react";

export interface TreeItemSlots {
  slots: { item: JSXElementConstructor<TreeItemProps> };
  slotProps: { item: Partial<TreeItemProps> };
}

/**
 * Pairs a module-level tree item component with the extra props it needs from its parent.
 *
 * RichTreeView remounts every item when `slots.item` changes identity, which wipes item state
 * such as an open menu or an in-progress rename. Passing parent values through `slotProps.item`
 * instead re-renders items without remounting them. MUI types both as plain TreeItemProps but
 * forwards the extra props to the item unchanged.
 */
export const treeItemSlots = <P extends object>(
  component: JSXElementConstructor<TreeItemProps & NoInfer<P>>,
  props: P,
): TreeItemSlots => ({
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- RichTreeView supplies the extra props from slotProps.item below
  slots: { item: component as JSXElementConstructor<TreeItemProps> },
  slotProps: { item: props },
});
